<template>
	<div id="optimization-group-loading" class="history-routing-content">
		<div class="vx-row">
			<div class="vx-col w-full" v-if="isOptimizationDetail">
				<vx-card no-shadow style="min-height: 80vh">
					<template slot="actions">
						<div class="flex items-center">
							<h6 class="item-name font-semibold">
								{{ $t("Group.Group") }} N. {{ groupsObject.dataGroup.id }} -
								{{ groupsObject.dataGroup.name }}
							</h6>
						</div>
						<vs-chip class="ag-grid-cell-chip float-right mt-4" :color="chipColor(groupsObject.statu)">
							<i class="material-icons mr-1">{{
								groupsObject.statu === "FINALIZED"
									? "check_circle"
									: groupsObject.statu === "PROCESSING"
									? "autorenew"
									: "error"
							}}</i>
							<span class="uppercase">{{
								groupsObject.statu === "FINALIZED"
									? $t("Optimization.OptimizationsCompleted")
									: groupsObject.statu === "PROCESSING"
									? $t("Optimization.OptimizationsInProgress")
									: $t("Optimization.OptimizationsWithErrors")
							}}</span>
						</vs-chip>
					</template>
					<group-optimization-item
						:optimizationList="optimizationList"
						@closeOptimizationDetail="closeOptimizationDetail()"
					/>
				</vx-card>
			</div>
			<div class="vx-col w-full" v-else-if="optimizationGroupList.length > 0">
				<div class="flex items-center justify-between">
					<vs-input
						v-model="searchQuery"
						class="w-full md:w-1/2"
						:placeholder="$t('Add') + '  Id ' + $t('Or') + ' ' + $t('Name')"
					/>
					<vs-pagination
						:total="totalPages > newPages ? newPages : totalPages"
						:max="9"
						v-model="currentPage"
						class="mb-2"
					/>
				</div>
				<div v-if="searchOptimizationGroup.length > 0" class="demo-alignment">
					<group-optimization-history-item
						ref="RoutingHistoryItem"
						v-for="(tr, indextr) in searchOptimizationGroup"
						:key="indextr"
						:item="tr"
						@showOptimizationByStatus="getOptimizationByStatus"
					></group-optimization-history-item>
				</div>
				<p class="mt-10 text-center font-semibold text-secondary" v-else>
					{{ $t("NoResultsWereFoundForYourSearch") }}
				</p>
			</div>
		</div>
	</div>
</template>

<script>
import vSelect from "vue-select";
import moduleOptimizationGroup from "@/store/optimization-group/moduleOptimizationGroup.js";
import moduleOptimization from "@/store/optimization/moduleOptimization.js";
import GroupOptimizationHistoryItem from "./GroupOptimizationHistoryItem.vue";
import GroupOptimizationItem from "./GroupOptimizationItem.vue";

export default {
	name: "routing-history",
	components: {
		vSelect,
		GroupOptimizationHistoryItem,
		GroupOptimizationItem,
	},
	data() {
		return {
			newPages: 2000,
			currentPageLocal: 1,
			optimizationGroupList: [],
			optimizationList: [],
			isOptimizationDetail: false,
			groupsObject: {},
			searchQuery: null,
			pagination: {
				next_page: 0,
				total_pages: 0,
				total_records: 0,
			},
		};
	},
	watch: {
		currentPageLocal(page) {
			this.handleChangePage(page);
		},
	},
	computed: {
		totalPages() {
			if (this.pagination.total_pages > 0) return this.pagination.total_pages;
			else return 0;
		},
		currentPage: {
			get() {
				return this.currentPageLocal;
			},
			set(val) {
				this.currentPageLocal = val;
			},
		},
		chipColor() {
			return (value) => {
				if (value === "FINALIZED") {
					this.percent = 100;
					this.loading = false;
					return "success";
				}
				if (value === "ERROR") {
					this.percent = 100;
					this.loading = false;
					return "danger";
				} else if (value === "PROCESSING") {
					this.loading = true;
					return "primary";
				} else return "secondary";
			};
		},
		searchOptimizationGroup() {
			const isSearchQueryEmpty = !this.searchQuery || this.searchQuery.trim().length === 0;
			if (isSearchQueryEmpty) {
				return this.optimizationGroupList;
			}
			return this.optimizationGroupList.filter((r) => {
				const query = this.searchQuery.toLowerCase();
				return r.name.toLowerCase().includes(query) || r.id.toString().toLowerCase().includes(query);
			});
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		/**
		 * Get para listar los documentos procesador en ruteo por el usuario
		 * @param {page} page - Id de la página actual en la paginación
		 * @returns {Array} Array - Retorna la lista de todos los documentos del usuario por página
		 */
		getOptimizationGroup(page) {
			this.openLoading();
			const payload = {
				sort: "desc",
				page,
				quantity: 3,
				order_by: ["id"],
			};
			this.$store
				.dispatch("moduleOptimizationGroup/optimizationGroupFilter", payload)
				.then((res) => {
					this.optimizationGroupList = res.records;
					Object.assign(this.pagination, res.pagination);
					this.closeLoading();
					return res;
				})
				.catch((err) => {
					this.closeLoading();
					console.error(err);
				});
		},
		getOptimizationByStatus(data) {
			this.groupsObject = data;
			this.$vs.loading({
				container: "#optimization-group-loading",
				scale: 1,
			});
			const dataPage = {
				status: [data.statu],
				optimization_group_id: [data.dataGroup.id],
				order_by: ["id"],
				sort: "desc",
			};
			this.$store
				.dispatch("moduleOptimization/optimizationFilter", dataPage)
				.then((res) => {
					this.optimizationList = res.records;
					this.isOptimizationDetail = true;
					this.$vs.loading.close("#optimization-group-loading > .con-vs-loading");
				})
				.catch((err) => {
					this.$vs.loading.close("#optimization-group-loading > .con-vs-loading");
					console.error(err);
				});
		},
		/**
		 * Maneja la páginación de la la tabla dinámicamente
		 * @param {page} page - Id de la siguiente página
		 * @returns {undefined}
		 */
		handleChangePage(page) {
			this.getOptimizationGroup(page);
		},
		closeOptimizationDetail(val) {
			this.isOptimizationDetail = val;
		},
	},
	created() {
		if (!moduleOptimizationGroup.isRegistered) {
			this.$store.registerModule("moduleOptimizationGroup", moduleOptimizationGroup);
			moduleOptimizationGroup.isRegistered = true;
		}
		if (!moduleOptimization.isRegistered) {
			this.$store.registerModule("moduleOptimization", moduleOptimization);
			moduleOptimization.isRegistered = true;
		}
		this.getOptimizationGroup(1);
	},
};
</script>

<style lang="scss" scoped>
.history-routing-content {
	scroll-behavior: smooth;
}
.demo-alignment {
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-start;
	align-items: center;

	& > * {
		margin-right: 1rem;
		margin-top: 0.5rem;
	}
}
</style>
